import React from 'react';
import Spinner from 'react-spinkit';

import styles from './loader.module.scss';


const Loader = () => (
    <div className={styles.loaderWrapper}>
        <div className={styles.loadingContainer}>
            <Spinner className={styles.spinner} name="circle"/>
        </div>
    </div>
);

export default Loader;
